import React, { useState, useEffect } from "react";
import styles from "./UserManagement.module.scss";
import {
    Button,
    Card,
    Col,
    Form,
    Modal,
    Row,
    Pagination,
    Container,
    Table,
    InputGroup,
} from "react-bootstrap";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import DataManager from "../../../General/DataManager";
import UserClass from "../../../General/LocalStorage/UserClass";



const UserManagement = () => {

    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit] = useState(10);
    const [search, setSearch] = useState("");
    const [getListError, setGetListError] = useState(null);
    const [totalResults, setTotalResults] = useState(0);

    const roleLabels = {
        OPERATOR: t("role_operator"),
        DEVICE_MANAGER: t("role_device_manager"),
        OPERATOR_CHECKIN: t("role_operator_checkin"),
        OPERATOR_SUPERVISOR: t("role_operator_supervisor"),
        SYSADMIN: t("role_sysadmin"),
        BOARDING_OPERATOR: t("role_boarding_operator"),

    };


    const navigate = useNavigate();
    useEffect(() => {
        getUsers(page, search);
    }, [page, search]);


    const getUsers = async (pageNumber = 1, searchValue = search) => {

        let instance = UserClass.getInstance();
        let token = instance.getTokenUser();
        const { data, msgError } = await DataManager.getUsers(token, {
            page: pageNumber,
            limit: limit,
            search: searchValue
        });

        if (msgError) {
            setGetListError(msgError);
            return;
        }
        console.log("results: ", data["results"])
        setUsers(data["results"])
        setTotalPages(data["pagination"]["totalPages"]);
        setPage(data["pagination"]["page"]);
        setTotalResults(data.pagination.totalResult);

    }


    return (
        <div className={styles.UserManagement}>
            <Container fluid="md">
                {/* Header */}
                <Row className="mb-4 align-items-center">
                    <Col>
                        <h2 className={styles.title}>
                            <i className="fa fa-users me-2"></i>
                            {t("user_management")}
                        </h2>
                        <p className={styles.subtitle}>{t("manage_users")}</p>
                    </Col>
                    <Col xs="auto">
                        <Button className="btn-primary" onClick={() => navigate(`/pages/UserManagement/newUser`)
                        }>
                            <i className="fa fa-plus me-1"></i>
                            {t("add_user")}
                        </Button>
                    </Col>
                </Row>

                {/* Search */}
                <Card className="mb-4">
                    <Card.Body>
                        <Row>
                            <Col md={6}>
                                <Form.Label className="fw-semibold">{t("search")}</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text>
                                        <i className="fa fa-search"></i>
                                    </InputGroup.Text>
                                    <Form.Control placeholder={t("search_by_name_email")} onChange={(e) => {
                                        setSearch(e.target.value.length >= 3 ? e.target.value : "");
                                        setPage(1)
                                    }} />
                                </InputGroup>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                {/* Users Table */}
                <Card>
                    <Card.Body className="p-0">
                        <Table responsive hover className="align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>{t("firstName")}</th>
                                    <th>{t("lastName")}</th>
                                    <th>{t("email")}</th>
                                    <th>{t("phone")}</th>
                                    <th>{t("role")}</th>
                                    <th>{t("status")}</th>
                                    <th>{t("created_at")}</th>
                                    <th>{t("updated_at")}</th>
                                    {/*<th className="text-end">{t("actions")}</th>*/}
                                </tr>
                            </thead>

                            <tbody>
                                {users?.map((user) => (
                                    <tr key={user.id} className={styles.clickableRow}
                                        onClick={() => navigate(`/pages/UserManagement/Details/${user.id}`)
                                        }
                                    >
                                        <td>{user.firstName}</td>
                                        <td>{user.lastName}</td>
                                        <td>{user.email}</td>
                                        <td>{user.phoneNumber}</td>
                                        <td>{roleLabels[user?.role]}</td>
                                        <td>
                                            <span
                                                className={
                                                    user.status === "ACTIVE"
                                                        ? styles.active
                                                        : styles.inactive
                                                }
                                            >
                                                {user.status}
                                            </span>
                                        </td>
                                        <td>
                                            { user?.createdAt ? new Date(user?.createdAt).toLocaleString("it-IT") : ''}
                                        </td>
                                        <td>
                                            {user?.updatedAt ? new Date(user?.updatedAt).toLocaleString("it-IT"): ''}
                                        </td>


                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                    </Card.Body>
                </Card>

                {/* Pagination */}
                {/* Pagination */}
                <div className="mt-4 d-flex justify-content-between align-items-center">
                    <div className="text-muted">
                        {t("showing")}{" "}
                        {(page - 1) * limit + 1}–
                        {Math.min(page * limit, totalResults)}{" "}
                        {t("of")} {totalResults} {t("results")}
                    </div>

                    <Pagination className="mb-0">
                        <Pagination.Prev
                            disabled={page === 1}
                            onClick={() => setPage(page - 1)}
                        />

                        {[...Array(totalPages)].map((_, i) => (
                            <Pagination.Item
                                key={i + 1}
                                active={i + 1 === page}
                                onClick={() => setPage(i + 1)}
                            >
                                {i + 1}
                            </Pagination.Item>
                        ))}

                        <Pagination.Next
                            disabled={page === totalPages}
                            onClick={() => setPage(page + 1)}
                        />
                    </Pagination>
                </div>

            </Container>
        </div>
    );
};

export default UserManagement;